<template>
    <div class="project" >

      <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
          <img id="navbar-logo" src="../../assets/projects/xrdls/philipsInternship.jpg" alt="Solid Logo">
      </div>
    </nav>

<h1>Charting My Career Path @Philips Design</h1>

<p>Having embarked on an exciting journey as a freelancer for Philips Design, my time there has spanned over two and a half fulfilling years of doing my internship and working full time for Philips Design.</p>

<h2>Navigating the Healthcare Design Landscape in Mixed Reality</h2>

<p>During my graduation internship at Philips, I was privileged to contribute to the Mixed Reality Toolkit (MRTK) Design Language System. My focus was squarely on the transition from conventional 2D to cutting-edge 3D design principles. This opportunity not only deepened my expertise in immersive technologies but also opened my eyes to the innovative world of healthcare design.</p>

<h2>Connecting the Dots: Merging 2D and 3D Design in Healthcare Technology</h2>

<p>A pivotal aspect of my internship revolved around exploring the profound differences between 2D and 3D design. In the realm of healthcare technology, transitioning from traditional 2D interfaces to immersive 3D spaces is transformative. In the 2D design landscape, interactions are confined to touch, click, and scroll on flat screens. However, the emergence of Mixed Reality propels the user into a three-dimensional realm, demanding new considerations such as spatial awareness, depth perception, and intuitive gestures.</p>

<h2>Crafting User-Centric Interfaces for Immersive Healthcare Experiences</h2>

<p>Designing an intuitive interface for a Mixed Reality medical imaging application necessitates a deep understanding of how users perceive depth, manipulate objects, and navigate the 3D environment. Principles of user-centered design and ergonomic considerations gain even more significance in this context, ensuring that healthcare professionals can seamlessly interact with complex data visualizations in a natural and efficient manner.</p>
<br>
<video class="vid" src="../../assets/projects/xrdls/mrtk.mp4" muted controls autoplay></video>

<h2>Pioneering the xrDLS Toolkit: A Revolution in Healthcare Design</h2>

<p>My time at Philips also included a rewarding involvement in the development of the Unity toolkit known as "xrDLS" (Extended Reality Design Language System). This toolkit acts as a bridge between MRTK and Philips' unique design requirements, specifically tailored for the challenges posed by healthcare technology.</p>

<h2>Empowering Developers for Consistent Mixed Reality Excellence</h2>

<p>xrDLS is designed to optimize the integration of Philips' medical devices and data visualization tools with the MRTK platform, ensuring that the resulting applications adhere to both industry standards and the renowned user-centered design principles that Philips upholds. The toolkit offers pre-designed 3D components, standardized color schemes, and interactive elements to streamline development, maintaining a consistent look and feel across various applications. This not only accelerates development but also enhances the end-user experience, fostering familiarity and reducing cognitive load.</p>

<h2>My Odyssey in the Future of Healthcare Technology</h2>

<p>My internship was an enriching journey that provided valuable insights into the evolving landscape of healthcare technology. It also allowed me to contribute to a project with the potential to revolutionize how medical professionals interact with complex data. My time at Philips was a blend of challenges and rewards, and I'm proud to have applied my design skills, learned from industry experts, and contributed to a team pushing the boundaries of Mixed Reality healthcare solutions.</p>

<h2>The Philips xrDLS Initiative: Unifying UX, UI, and Development</h2>

<p>During my internship, I was immersed in a multifaceted project that encompassed UX, UI, and development – the xrDLS initiative. This undertaking revolved around creating a Philips-compliant toolkit specially crafted for AR and VR applications.</p>

<h2>Meet Davey Hurkmans: A Journey in Philips Design</h2>

<p>When I embarked on my graduation internship, I had the privilege of joining Philips Design. This project centered around the Philips Design Language System (DLS), which outlines the requirements for Philips-designed products. However, for extended reality products, new design criteria had to be established, marking the inception of my journey.</p>

<h2>The Synergy of Collaborative Design and Extended Reality</h2>

<p>Within Philips Design, the pursuit of "human-centered design" is paramount, especially in the healthcare domain. The objective is to enrich the lives of millions every day with Philips' innovative products.</p>

<h2>Forging the Path to a Unified Approach in AR and VR</h2>

<p>Alongside two fellow students, Brend Smits and Vincent Venhuizen, from Fontys Open Innovation, I embarked on the challenge of realizing this system. The primary focus of this project was to establish a foundation upon which all future AR/VR content would be built. Together with this toolkit and strict guidelines and documentation on how to develop and design within the mixed reality realm, our hope is to unify AR/VR applications within Philips.</p>

<h2>Shaping the Foundations of xrDLS</h2>

<p>Working closely with Vincent, I laid the groundwork for all essential components added to the Unity project. This foundation comprises of:</p>
<ul>
  <li>Materials</li>
  <li>Shaders</li>
  <li>Icons</li>
  <li>Audio</li>
  <li>Animation</li>
  <li>Themes</li>
</ul>
<br>
<video class="vid" src="../../assets/projects/xrdls/assets.mp4" muted controls autoplay></video>

<h2>Reflecting on the Journey and Gazing Forward</h2>

<p>This semester has been a significant personal learning experience for me, both professionally and within the Philips organization. My individual contributions to the project have been met with enthusiasm, and I've cultivated a strong connection to Philips as an organization.</p>

<h2>Exploring Future Prospects and Ongoing Development</h2>

<p>The period between documentation submission and the final presentation will be focused on tying up loose ends. This includes the development of interaction scripts supporting MRTK and enhancing the system's user-friendliness for those with limited technical expertise. Additionally, we will be transitioning an interactive menu from VRTK to our chosen toolkit, MRTK.</p>

<h2>My Evolving Journey</h2>

<p>As my contract with Philips is set to continue until August 31, my focus will be on these transitional tasks and issue resolution within the xrDLS GitHub repository. Simultaneously, I'll be contemplating my next steps, which could involve further collaboration with Philips or exploration of opportunities with partner companies like Frog and Capgemini.</p>

<h2>A Journey of Fulfillment</h2>

<p>Looking back, I take great pride in the results we've achieved, and I'm thrilled by the potential impact of xrDLS on the healthcare industry. This isn't just a career progression; it's a leap into a future where 3D design and mixed reality redefine our perception and interaction with information. Philips' dedication to innovation and human-centered design has left an indelible mark on me, and I eagerly anticipate continuing this adventure in the realm of design and immersive technologies.</p>


</div>
</template>

  
  <style scoped>
  
  @import 'project.css';
  
  </style>